import { zoop } from "../config/ZoopConfig";
import { ApiZoop } from "./Api";

const ValidaCartaoCreditoZoop = async(cardData) => {
      const { data } = await ApiZoop.post(
        `v1/marketplaces/${zoop.ZOOP_MARKETPLACE_ID}/cards/tokens`,
        cardData
      );

      return data
  }


export {ValidaCartaoCreditoZoop}